import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import { EveReportingWidget } from '../widget.component';
import { BehaviorSubject,  Observable } from 'rxjs';
import { EveReportingWidgetDataSource } from '../widget-menu-settings/widget-datasource/widget-datasource.component';
import { iDataSource, IDataSourceService } from '../../../services/DataSourceServices/IDataSourceService.service';
import { StackedBarChartOptions } from '../../charts/stacked-bar-chart/stacked-bar-chart.component';
import { Multi } from '../../../interfaces/multi.interface';

@Component({
  selector: 'bar-chart-widget',
  templateUrl: 'bar-chart-widget.component.html',
  styleUrls: ['./bar-chart-widget.component.css']
})
export class BarChartWidgetComponent {


  options: StackedBarChartOptions;

  @Input()
  widget?: EveReportingBarChartWidget = null;

  @Output()
  isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  hasErrored: EventEmitter<boolean> = new EventEmitter<boolean>();

  widgetObservables: BehaviorSubject<EveReportingWidget>;

  results: Observable<Multi[]>;


  
  constructor(
    public dataSourceService: IDataSourceService
  )
  {

  }


  ngOnInit(): void {
    this.isLoading.emit(false);
    this.hasErrored.emit(false);

    this.options = {
      width: null,
      height: null,
      chartHeader: null,
      xAxisLabel: this.widget?.xAxisLabel,
      yAxisLabel: this.widget?.yAxisLabel,
      colourScheme: this.widget?.colourScheme
    }

    this.widgetObservables = new BehaviorSubject<EveReportingWidget>(JSON.parse(JSON.stringify(this.widget)));
    this.results = this.dataSourceService.MultiResults(this.widgetObservables, staticResults);
  }

  ngDoCheck(): void {
    if (this.options.xAxisLabel != this.widget?.xAxisLabel) this.options.xAxisLabel = this.widget?.xAxisLabel;
    if (this.options.yAxisLabel != this.widget?.yAxisLabel) this.options.yAxisLabel = this.widget?.yAxisLabel;
    if (this.options.colourScheme != this.widget?.colourScheme) this.options.colourScheme = this.widget?.colourScheme;

    if (JSON.stringify(this.widget) !== JSON.stringify(this.widgetObservables.value)) this.widgetObservables.next(JSON.parse(JSON.stringify(this.widget)));
  }


  public onSelect(data) {
    //this.select.emit(data);
    alert("hi");
  }


}




export interface EveReportingBarChartWidget extends EveReportingWidget, iDataSource {
  xAxisLabel?: string,
  yAxisLabel?: string,
  colourScheme?: any,

  dataSource: EveReportingWidgetDataSource

}


const staticResults: Multi[] = [
  {
    name: "User1",
    series: [
      {
        name: "Missed",
        value: 13
      },
      {
        name: "Answered",
        value: 45
      },
      {
        name: "Voicemail",
        value: 23
      }
    ]
  },
  {
    name: "User2",
    series: [
      {
        name: "Missed",
        value: 20
      },
      {
        name: "Answered",
        value: 34
      },
      {
        name: "Voicemail",
        value: 12
      }
    ]
  },
  {
    name: "User3",
    series: [
      {
        name: "Missed",
        value: 25
      },
      {
        name: "Answered",
        value: 36
      },
      {
        name: "Voicemail",
        value: 7
      }
    ]
  }, {
    name: "User21",
    series: [
      {
        name: "Missed",
        value: 13
      },
      {
        name: "Answered",
        value: 45
      },
      {
        name: "Voicemail",
        value: 23
      }
    ]
  },
  {
    name: "User22",
    series: [
      {
        name: "Missed",
        value: 20
      },
      {
        name: "Answered",
        value: 34
      },
      {
        name: "Voicemail",
        value: 12
      }
    ]
  },
  {
    name: "User23",
    series: [
      {
        name: "Missed",
        value: 25
      },
      {
        name: "Answered",
        value: 36
      },
      {
        name: "Voicemail",
        value: 7
      }
    ]
  }, {
    name: "User31",
    series: [
      {
        name: "Missed",
        value: 13
      },
      {
        name: "Answered",
        value: 45
      },
      {
        name: "Voicemail",
        value: 23
      }
    ]
  },
  {
    name: "User32",
    series: [
      {
        name: "Missed",
        value: 20
      },
      {
        name: "Answered",
        value: 34
      },
      {
        name: "Voicemail",
        value: 12
      }
    ]
  },
  {
    name: "User33",
    series: [
      {
        name: "Missed",
        value: 25
      },
      {
        name: "Answered",
        value: 36
      },
      {
        name: "Voicemail",
        value: 7
      }
    ]
  },
  {
    name: "User43",
    series: [
      {
        name: "Missed",
        value: 25
      },
      {
        name: "Answered",
        value: 36
      },
      {
        name: "Voicemail",
        value: 7
      }
    ]
  },
  {
    name: "User53",
    series: [
      {
        name: "Missed",
        value: 25
      },
      {
        name: "Answered",
        value: 36
      },
      {
        name: "Voicemail",
        value: 7
      }
    ]
  },
];
